/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DummyMGear, DummyMGearInterface } from "../DummyMGear";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgearId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mgearAssets",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenIdToMGear",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DummyMGear__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DummyMGear> {
    return super.deploy(overrides || {}) as Promise<DummyMGear>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DummyMGear {
    return super.attach(address) as DummyMGear;
  }
  connect(signer: Signer): DummyMGear__factory {
    return super.connect(signer) as DummyMGear__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DummyMGearInterface {
    return new utils.Interface(_abi) as DummyMGearInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DummyMGear {
    return new Contract(address, _abi, signerOrProvider) as DummyMGear;
  }
}
